/* =============================================================
   Birth Profile Analyst — Achtergrond-animatie instellingen
   -------------------------------------------------------------
   Voegt een tandwiel-knop toe (linksonder) met schuifregelaars
   voor de plexus-achtergrond: aantal lijnen, snelheid, zichtbaar-
   heid. Keuze wordt bewaard in localStorage ('bpa_anim') en geldt
   op alle pagina's. De plexus-animatie leest window.BPAAnim.
   ============================================================= */
(function () {
  "use strict";
  var KEY = "bpa_anim";
  var DEF = { density: 56, speed: 52, opacity: 100, numbers: 24 };
  var LANG = (localStorage.getItem("bpa_lang") || "nl") === "en" ? "en" : "nl";

  function read() {
    try { return Object.assign({}, DEF, JSON.parse(localStorage.getItem(KEY)) || {}); }
    catch (e) { return Object.assign({}, DEF); }
  }
  function write(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  var S = read();
  var subs = [];
  function notify() { for (var i = 0; i < subs.length; i++) { try { subs[i](); } catch (e) {} } }

  /* API used by the plexus animation on every page */
  window.BPAAnim = {
    count: function (mob) { var max = mob ? 80 : 160; return Math.max(0, Math.round(max * S.density / 100)); },
    get speed() { return (S.speed / 50) * 0.55; },        // 50 -> 0.55 (baseline)
    get alpha() { return (S.opacity / 100) * 0.25; },     // 56 -> ~0.14 (baseline)
    get numbersSpeed() { return Math.max(0.15, S.numbers / 50); }, // 50 -> 1x (baseline)
    get settings() { return Object.assign({}, S); },
    subscribe: function (fn) { subs.push(fn); }
  };

  /* Hide the gear only inside the Mobiele preview phone frames (marked ?embed=1) */
  try { if (new URLSearchParams(location.search).get("embed")) return; } catch (e) {}

  var T = {
    nl: { title: "Achtergrond", lines: "Lijnen", speed: "Snelheid", vis: "Zichtbaarheid", numbers: "Cijfers",
          reset: "Standaard herstellen", open: "Animatie-instellingen", close: "Sluiten" },
    en: { title: "Background", lines: "Lines", speed: "Speed", vis: "Visibility", numbers: "Numbers",
          reset: "Reset to default", open: "Animation settings", close: "Close" }
  };
  var L = T[LANG];

  function injectStyle() {
    if (document.getElementById("bpa-anim-style")) return;
    var css =
      ".bpa-anim-gear{position:fixed;left:20px;bottom:20px;z-index:9998;width:46px;height:46px;border-radius:50%;" +
        "border:1px solid rgba(201,169,106,0.4);background:rgba(10,23,51,0.82);backdrop-filter:blur(8px);" +
        "color:#c9a96a;cursor:pointer;display:grid;place-items:center;transition:background .25s,border-color .25s,transform .3s;box-shadow:0 10px 30px rgba(0,0,0,0.4)}" +
      ".bpa-anim-gear:hover{border-color:#c9a96a;background:rgba(201,169,106,0.16);transform:rotate(35deg)}" +
      ".bpa-anim-gear svg{width:20px;height:20px}" +
      ".bpa-anim-panel{position:fixed;left:20px;bottom:78px;z-index:9998;width:290px;background:linear-gradient(180deg,#0d1f42,#0a1733);" +
        "border:1px solid rgba(201,169,106,0.35);box-shadow:0 24px 60px rgba(0,0,0,0.5);padding:22px 22px 20px;" +
        "opacity:0;transform:translateY(12px) scale(.97);pointer-events:none;transition:opacity .28s,transform .28s}" +
      ".bpa-anim-panel.show{opacity:1;transform:none;pointer-events:auto}" +
      ".bpa-anim-panel::before{content:'';position:absolute;top:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,#c9a96a,transparent)}" +
      ".bpa-anim-h{display:flex;align-items:center;justify-content:space-between;margin:0 0 16px}" +
      ".bpa-anim-h .t{font-family:'JetBrains Mono',ui-monospace,monospace;font-size:10px;letter-spacing:.3em;text-transform:uppercase;color:#c9a96a}" +
      ".bpa-anim-h .x{background:none;border:0;color:#8b94ad;cursor:pointer;font-size:18px;line-height:1;padding:0 2px}" +
      ".bpa-anim-h .x:hover{color:#f3ead6}" +
      ".bpa-anim-row{margin:0 0 16px}" +
      ".bpa-anim-row label{display:flex;justify-content:space-between;font-family:'JetBrains Mono',ui-monospace,monospace;font-size:9px;" +
        "letter-spacing:.18em;text-transform:uppercase;color:#8b94ad;margin:0 0 9px}" +
      ".bpa-anim-row label .v{color:#e7c98a}" +
      ".bpa-anim-row input[type=range]{-webkit-appearance:none;appearance:none;width:100%;height:2px;background:rgba(201,169,106,0.3);outline:none;margin:0}" +
      ".bpa-anim-row input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:#c9a96a;cursor:pointer;border:0;box-shadow:0 0 0 4px rgba(201,169,106,0.15)}" +
      ".bpa-anim-row input[type=range]::-moz-range-thumb{width:16px;height:16px;border-radius:50%;background:#c9a96a;cursor:pointer;border:0}" +
      ".bpa-anim-reset{display:block;width:100%;margin-top:4px;background:transparent;border:1px solid rgba(201,169,106,0.3);color:#cfd6e8;" +
        "font-family:'JetBrains Mono',ui-monospace,monospace;font-size:9px;letter-spacing:.2em;text-transform:uppercase;padding:11px;cursor:pointer;transition:background .25s,color .25s,border-color .25s}" +
      ".bpa-anim-reset:hover{background:#c9a96a;color:#0a1733;border-color:#c9a96a}";
    var st = document.createElement("style");
    st.id = "bpa-anim-style";
    st.textContent = css;
    document.head.appendChild(st);
  }

  var panel, gear, rows = {};
  function row(keyName, label) {
    var wrap = document.createElement("div");
    wrap.className = "bpa-anim-row";
    var lab = document.createElement("label");
    lab.innerHTML = label + ' <span class="v">' + S[keyName] + '%</span>';
    var inp = document.createElement("input");
    inp.type = "range"; inp.min = "0"; inp.max = "100"; inp.step = "1"; inp.value = S[keyName];
    inp.addEventListener("input", function () {
      S[keyName] = parseInt(inp.value, 10);
      lab.querySelector(".v").textContent = S[keyName] + "%";
      write(S);
      notify();
    });
    rows[keyName] = inp;
    wrap.appendChild(lab);
    wrap.appendChild(inp);
    return wrap;
  }

  function build() {
    injectStyle();

    gear = document.createElement("button");
    gear.type = "button";
    gear.className = "bpa-anim-gear";
    gear.setAttribute("aria-label", L.open);
    gear.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">' +
      '<line x1="4" y1="7" x2="20" y2="7"/><circle cx="9" cy="7" r="2.4" fill="#0a1733"/>' +
      '<line x1="4" y1="17" x2="20" y2="17"/><circle cx="15" cy="17" r="2.4" fill="#0a1733"/></svg>';

    panel = document.createElement("div");
    panel.className = "bpa-anim-panel";

    var head = document.createElement("div");
    head.className = "bpa-anim-h";
    head.innerHTML = '<span class="t">' + L.title + '</span>';
    var x = document.createElement("button");
    x.className = "x"; x.type = "button"; x.setAttribute("aria-label", L.close); x.innerHTML = "&times;";
    x.addEventListener("click", toggle);
    head.appendChild(x);
    panel.appendChild(head);

    panel.appendChild(row("density", L.lines));
    panel.appendChild(row("speed", L.speed));
    if (document.getElementById("drift")) panel.appendChild(row("numbers", L.numbers));
    panel.appendChild(row("opacity", L.vis));

    var reset = document.createElement("button");
    reset.className = "bpa-anim-reset"; reset.type = "button"; reset.textContent = L.reset;
    reset.addEventListener("click", function () {
      S = Object.assign({}, DEF); write(S); notify();
      Object.keys(rows).forEach(function (k) {
        rows[k].value = S[k];
        var lab = rows[k].parentNode.querySelector(".v");
        if (lab) lab.textContent = S[k] + "%";
      });
    });
    panel.appendChild(reset);

    gear.addEventListener("click", toggle);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("show")) toggle();
    });

    document.body.appendChild(gear);
    document.body.appendChild(panel);
  }

  function toggle() { panel.classList.toggle("show"); }

  if (document.readyState !== "loading") build();
  else document.addEventListener("DOMContentLoaded", build);
})();
